const utilities = [
  {
    name: "useDatabaseConnection",
    displayName: "Database Connection",
    description:
      "Sets up a live connection to the database that will update anytime data is changed",
    props: [
      {
        name: "_table",
        displayName: "Select table",
        editor: "table",
        editorParams: {},
      },
      {
        name: "_filters",
        displayName: "Filters",
        editor: "dataFilters",
        editorParams: { default: null, type: "_table" },
        help: "",
      },
      {
        name: "_sort",
        displayName: "Sort",
        editor: "dataSort",
        editorParams: { default: null, type: "_table" },
        help: "",
      },
    ],
    returning: [
      {
        kind: "data",
        name: "data",
        displayName: "Data",
        type: "_table",
        list: true,
      },
      {
        kind: "data",
        name: "loading",
        displayName: "is loading",
        type: "True/False",
        list: false,
      },
      {
        kind: "action",
        name: "refetch",
        displayName: "Refetch Data",
        async: false,
      },
    ],
  },
  {
    name: "useApiCall",
    displayName: "Api Call",
    description: "Get data from an api",
    props: [
      {
        name: "api",
        displayName: "Api",
        editor: "apis",
        editorParams: {},
      },
    ],
    returning: [
      {
        kind: "data",
        name: "data",
        displayName: "Data",
        type: "api.type",
        list: "api.list",
      },
      {
        kind: "data",
        name: "loading",
        displayName: "is loading",
        type: "True/False",
        list: false,
      },
      {
        kind: "action",
        name: "refetch",
        displayName: "Refetch Data",
        async: false,
      },
    ],
  },
  {
    name: "usePageState",
    displayName: "State Varaible",
    description:
      "Creates a data source that will cause your page to change whenever it is updated",
    props: [
      {
        name: "type",
        displayName: "Data type",
        editor: "appType",
        editorParams: {},
      },
      {
        name: "list",
        displayName: "List?",
        editor: "checkbox",
        editorParams: { true: true, false: false, default: false },
      },
      {
        name: "default",
        displayName: "Default Value",
        editor: "dynamic",
        editorParams: { type: "type", list: "list" },
      },
    ],
    returning: [
      {
        kind: "data",
        name: "value",
        displayName: "Value",
        type: "type",
        list: "list",
      },
      {
        kind: "action",
        name: "set",
        displayName: "Set Value",
        async: false,
        props: [
          {
            name: "value",
            displayName: "value",
            editor: "dynamic",
            editorParams: { type: "type", list: "list" },
          },
        ],
      },
    ],
  },
  {
    name: "useLocation",
    displayName: "Geographical Location",
    description: "Get current geographical location",
    props: [],
    returning: [
      {
        kind: "data",
        name: "location",
        displayName: "Geolocation",
        type : "Location",
        list: false
      },
      {
        kind: "data",
        name: "address",
        displayName: "Street Address",
        type: "Text",
        list: false      
      }
    ]
  },
  {
    name: "useDateList",
    displayName: "List of Dates",
    description:
      "Generates a list of dates that can be used to make a custom calendar",
    props: [
      {
        name: "date",
        displayName: "Refrence Date",
        editor: "dynamic",
        editorParams: { type: "Date", list: "false" },
      },
      {
        name: "period",
        displayName: "Week or Month",
        editor: "dropdown",
        editorParams: {
          options: [
            { value: "week", text: "Week" },
            { value: "month", text: "Month" },
          ],
        },
      },
      {
        name: "extra",
        displayName: "Create Extra Dates?",
        editor: "checkbox",
        editorParams: {
          default: true,
          true: true,
          false: false,
          styleName: true,
        },
        help:
          "Adds extra dates to begining of week to format correctly on calendar",
      },
    ],
    returning: [
      {
        kind: "data",
        name: "value",
        displayName: "Dates",
        type: "Date",
        list: true,
      },
    ],
  },
];

export default utilities;
